import React from "react";
import PropTypes from "prop-types";
import CustomLink from "@/bit/components/next13.components.custom-link";
import Telefonica from "@gerenciatd/next13.glyph.telefonica-reducido-m";
import { TAGGIN_INFO } from "../constants";

const MainLogo = ({ link, target }) => {
  return (
    <>
      <div className="main-logo">
        <CustomLink
          taggingInfo={{ ...TAGGIN_INFO, componentContent: "Telefónica" }}
          href={link}
          target={target}
          cyData={`Footer telefonica logo`}
        >
          <Telefonica
            width={158}
            color="GREY3"
            layoutSize={{ width: 158, height: 88 }}
          />
        </CustomLink>
      </div>
    </>
  );
};

export default MainLogo;

MainLogo.propTypes = {
  /**
   * {
   *  "info": "URL del logo",
   *  "kind": "both",
   *  "beautifulName": "URL del logo"
   * }
   */
  link: PropTypes.string,

  /**
   * {
   *  "info": "Target de la URL",
   *  "kind": "both",
   *  "beautifulName": "Target de la URL"
   * }
   */
  target: PropTypes.oneOf(["_blank", "_self", "_parent", "_top"]),
};

MainLogo.defaultProps = {
  link: "",
  target: "_self",
};
